<mat-toolbar>
  <a [href]="downloadURL$ | async" download target="_blank">
    <button mat-icon-button>
      <mat-icon>get_app</mat-icon>
    </button>
  </a>
  <!-- <button mat-icon-button fileSaver [method]="'GET'" [fileName]="downloadURL$ | async" [url]="downloadURL$ | async">
    <mat-icon>get_app</mat-icon>
  </button> -->
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu" yPosition="below" xPosition="before">
    <button mat-menu-item (click)="delete()">
      <mat-icon>delete</mat-icon>
      <span>Delete</span>
    </button>
  </mat-menu>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content (swipeleft)="next()" (swiperight)="prev()">
  <img *ngFor="let src of images$ | async; let i = index" [src]="src" [class.display-none]="i !== (slideIndex$ | async)">
</mat-dialog-content>

<!-- <div class="navigation navigation-left" (click)="prev()">
  <button mat-icon-button>
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
</div>

<div class="navigation navigation-right" (click)="next()">
  <button mat-icon-button>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div> -->